import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, BriefcaseIcon, WineIcon, SparklesIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: HeartIcon,
    title: t('services.bodas.title'),
    desc: t('services.bodas.desc')
  }, {
    icon: BriefcaseIcon,
    title: t('services.corp.title'),
    desc: t('services.corp.desc')
  }, {
    icon: WineIcon,
    title: t('services.rest.title'),
    desc: t('services.rest.desc')
  }, {
    icon: SparklesIcon,
    title: t('services.party.title'),
    desc: t('services.party.desc')
  }];
  return <section id="servicios" className="py-24 md:py-32 bg-ink2" data-id="element-148">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mb-16" data-id="element-150">
          <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-151">
            {t('services.eyebrow')}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight" data-id="element-152">
            {t('services.title.1')}{' '}
            <span className="italic gold-text" data-id="element-153">{t('services.title.2')}</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-154">
          {services.map((s, i) => {
          const Icon = s.icon;
          return <motion.div key={s.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="group relative p-8 border border-gold/20 hover:border-gold/60 bg-ink/50 transition-colors" data-id="element-155">
                <Icon size={28} className="text-gold mb-6" strokeWidth={1.5} data-id="element-156" />
                <h3 className="font-display text-xl text-cream mb-3" data-id="element-157">
                  {s.title}
                </h3>
                <p className="text-cream/60 text-sm leading-relaxed" data-id="element-158">
                  {s.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}